<mat-radio-group [formControl]="control"
                 class="smart-comparison-radios">
  <mat-radio-button [value]="comparison_opt" *ngFor="let comparison_opt of comparison_opts">
    {{ 'alerts.smart_alerts.smart_digest.configuration.comparison_opts.' + comparison_opt | translate }}
  </mat-radio-button>
</mat-radio-group>
